import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Card, Grid, Text } from '@aws-amplify/ui-react';
import PageBaseNoSignIn from '@components/pages/PageBaseNoSignIn';
import { FacilityState } from '@atom/FacilityState';
import { useRecoilValue } from 'recoil';

const GroupCompletePage = () => {
  const facility = useRecoilValue(FacilityState);
  const { facilityId } = facility;
  const navigate = useNavigate();

  // ホーム画面へ戻る
  const backHomePage = () => {
    navigate(`/c001/arealist?facilityId=${facilityId}`);
  };

  return (
    <PageBaseNoSignIn title="団体登録完了">
      <div>
        <br />
      </div>
      <Grid templateColumns={{ base: '1fr', large: '1fr' }}>
        <Card>
          <Text
            variation="primary"
            as="p"
            lineHeight="1.5em"
            fontWeight={400}
            fontSize="1em"
            fontStyle="normal"
            textDecoration="none"
            width="100%"
          >
            審査後、承認が下りたら利用ができるようになります。審査結果はメールで発送します。審査には○営業日お時間を頂いております。
          </Text>
        </Card>
        <Card>
          <Button variation="primary" isFullWidth onClick={backHomePage}>
            施設TOPへ
          </Button>
        </Card>
      </Grid>
    </PageBaseNoSignIn>
  );
};

export default GroupCompletePage;
